var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDatagrids(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2535,
    height: 1524,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 892,
    y: 409,
    width: 2535,
    height: 1524
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-892 -409)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1140.5,
    y: 411.5,
    width: 2072,
    height: 1325,
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1E3A8A",
    fontFamily: "Aharoni,Aharoni_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 440,
    transform: "matrix(1 0 0 1 1156.87 1534)"
  }, "data"), /*#__PURE__*/React.createElement("text", {
    fill: "#0284C7",
    fontFamily: "Aharoni,Aharoni_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 440,
    transform: "matrix(1 0 0 1 2119.94 1534)"
  }, "grids"), /*#__PURE__*/React.createElement("path", {
    d: "M1285.5 1141.5 3085.33 1141.5",
    stroke: "#1E3A8A",
    strokeWidth: 55,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1737.5,
    y: 498.5,
    width: 926,
    height: 563,
    stroke: "#0070C0",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#0284C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361 785 2956.19 785",
    stroke: "#FFFFFF",
    strokeWidth: 45.8333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2349.5 435.5 2349.5 1085.11",
    stroke: "#FFFFFF",
    strokeWidth: 55,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2020.5 435.5 2020.5 1085.11",
    stroke: "#FFFFFF",
    strokeWidth: 55,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDatagrids);
export default __webpack_public_path__ + "static/media/logo_datagrids.290ace3ff839d1125050ec625afa28aa.svg";
export { ForwardRef as ReactComponent };